unit uLockerDataStore_MySQL;

interface

uses
  System.SysUtils, System.Classes, WEBLib.JSON, Web,
  uLockerDataStore;

type
  TLockerDataStore_MySQL = class(TLockerDataStore)
  private
    FWebhookURL: string;
    FLockerID : string;
  public
    constructor Create(const AWebhookURL: string; const ALockerID: string );
    [async] function Add(AData: TJSONObject): Boolean; async; override;
    [async] function Read(): TLockerData; async; override;
    [async] function Update(AData: TJSONObject): Boolean; async; override;
    [async] function Delete(): Boolean; async; override;
    [async] function AddOrUpdate(AData: TJSONObject): Boolean; async; override;

    function GetLockerID : string; override;
    property LockerID : string read GetLockerID;
  end;

implementation

uses uConstants;

//==========================================================
constructor TLockerDataStore_MySQL.Create(const AWebhookURL: string; const ALockerID: string);
//==========================================================
begin
  inherited Create;
  FWebhookURL := AWebhookURL;
  FLockerID := ALockerID;
end;

//==========================================================
function TLockerDataStore_MySQL.GetLockerID: string;
//==========================================================
begin
  Result := FLockerID;
end;

//==========================================================
function TLockerDataStore_MySQL.Add(AData: TJSONObject): Boolean;
//==========================================================
begin
  // TODO: Implement webhook call with API_KEY
  Result := False;
end;

//==========================================================
function TLockerDataStore_MySQL.Read(): TLockerData;
//==========================================================
begin
  // TODO: Implement webhook call with API_KEY
  Result := nil;
end;

//==========================================================
function TLockerDataStore_MySQL.Update(AData: TJSONObject): Boolean;
//==========================================================
begin
  // TODO: Implement webhook call with API_KEY
  Result := False;
end;

//==========================================================
function TLockerDataStore_MySQL.Delete(): Boolean;
//==========================================================
begin
  // TODO: Implement webhook call with API_KEY
  Result := False;
end;

//==========================================================
function TLockerDataStore_MySQL.AddOrUpdate(AData: TJSONObject): Boolean;
//==========================================================
begin
  // TODO: Implement webhook call with API_KEY
  Result := False;
end;

end.
